import { render, staticRenderFns } from "./PaymentPlate.vue?vue&type=template&id=af57dd1c&scoped=true&"
import script from "./PaymentPlate.vue?vue&type=script&lang=js&"
export * from "./PaymentPlate.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPlate.vue?vue&type=style&index=0&id=af57dd1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af57dd1c",
  null
  
)

export default component.exports